import { ComponentProps, ReactNode } from 'react';

import { Modal, ModalSelect } from '@ingrid/luterkort-react';

type ModalSelectRootProps = ComponentProps<(typeof ModalSelect)['Root']>;
type ModalContentProps = ComponentProps<(typeof Modal)['Content']>;

export type SelectModalProps = {
  trigger: ReactNode;
  children: ReactNode;
} & Omit<ModalSelectRootProps, 'children'> &
  Omit<ModalContentProps, 'children'>;

export function SelectModal(props: SelectModalProps) {
  const { children, onValueChange, value, onSearchValueChange, searchValue, filterFactory, trigger, ...otherProps } =
    props;

  return (
    <ModalSelect.Root
      onValueChange={onValueChange}
      value={value}
      onSearchValueChange={onSearchValueChange}
      searchValue={searchValue}
      shouldCloseOnSelect={true}
      filterFactory={filterFactory}
    >
      <Modal.Root>
        <Modal.Trigger>{trigger}</Modal.Trigger>

        <Modal.Content {...otherProps}>{children}</Modal.Content>
      </Modal.Root>
    </ModalSelect.Root>
  );
}
